export default __webpack_public_path__ + "static/Inter-Regular-8002daa469a9b794c22017eee0a28070.woff";